import styled from 'styled-components';
import { isMobile } from 'react-device-detect';

export const Root = styled.div`
  .image-static .ant-image {
    width: 100%;
    display: block;
  }
`;
